import httpClient from "./client";

export const getTargetUsers = async (isActive) => {
  const response = await httpClient.get("/target-users/", {
    params: { isActive: isActive },
  });
  return response;
};

export const getTargetUsersPaginated = async (
  isActive,
  page,
  limit,
  sortBy,
  sortOrder
) => {
  const response = await httpClient.get("/target-users/paginated/", {
    params: {
      isActive,
      page,
      limit,
      sortBy,
      sortOrder,
    },
  });
  return response;
};

export const createTargetUser = async (targetUserData) => {
  const response = await httpClient.post("/target-users/", targetUserData);
  return response;
};

export const getTargetUserById = async (targetUserId) => {
  const response = await httpClient.get(`/target-users/${targetUserId}`);
  return response;
};

export const updateTargetUser = async (targetUserId, updateData) => {
  const response = await httpClient.put(
    `/target-users/${targetUserId}`,
    updateData
  );
  return response;
};
